<template>
  <div class="list-view">
    <transition
      name="fade"
      :css="false"
      @before-enter="beforeEnter"
      @enter="showList"
      @after-enter="afterEnter"
      @leave="hideList"
      mode="out-in">
      <div class="list-view__content" :class="{empty: items.length === 0}">
        <p v-if="items.length === 0">
          Deze lijst lijst is leeg. Voeg een product toe door op de plus rechts onderin te drukken.
          {{ getCurrentList().suggestions.length > 0 ? 'Of voeg een van de onderstaande suggesties toe' : '' }}
        </p>
        <v-list v-if="items.length > 0" :class="{shopping: shoppingState}" ref="list" id="list">
          <draggable v-model="items" :options="{handle:'.draggable', animation: 150}">
            <transition-group
              :css="false"
              @before-enter="beforeEnter"
              @enter="enter"
              @leave="leave">
              <list-item
                v-for="item in items"
                :key="listID + '--' + item.id"
                :item="item"
                :collected="item.collected"
                type="list"/>
            </transition-group>
          </draggable>
        </v-list>
      </div>
    </transition>

    <transition
      name="fade">
      <div class="list-view__suggestions" v-if="!shoppingState && shownSuggestedItems > 0">
        <p v-if="items.length !== 0">Suggesties voor de volgende keer dat je boodschappen haalt</p>
        <v-list ref="suggestions" id="suggest">
          <transition-group
            name="suggestions"
            :css="false"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave">
            <list-item
              v-show="dontShowSuggestionIfItemAlreadyOnList(item)"
              v-for="(item, index) in suggestedItems"
              :data-index="index"
              :key="listID + '--' + item.id"
              :item="item"
              type="category"/>
          </transition-group>
        </v-list>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ListItem } from '@/components/organisms'
  import draggable from 'vuedraggable'
  import {TweenMax, Power1} from 'gsap/TweenMax'

  export default {
    name: 'show-list',
    computed: {
      shoppingState () {
        return this.$store.state.commonStore.shopping
      },
      items: {
        get () {
          return this.getCurrentList().items
        },
        set (value) {
          this.$store.commit('UPDATE_LIST', value)
        }
      },
      suggestedItems () {
        // todo: only show the top 10 suggested items, not all of them
        return this.getCurrentList().suggestions ? this.getCurrentList().suggestions : []
      },
      shownSuggestedItems () {
        let shownSuggestedItemsCounter = 0
        this.suggestedItems.forEach(item => { if (this.dontShowSuggestionIfItemAlreadyOnList(item)) shownSuggestedItemsCounter += 1 })
        return shownSuggestedItemsCounter
      },
      listID () {
        return this.$store.state.listsStore.currentListId
      }
    },
    methods: {
      ...mapGetters({
        getCurrentList: 'getCurrentList'
      }),
      dontShowSuggestionIfItemAlreadyOnList (suggestedItem) {
        if (this.getCurrentList().items.find(item => item.id === suggestedItem.id)) return false
        else return true
      },
      beforeEnter (el) {
        el.style.opacity = 0
        el.style.height = 0
      },
      enter (el, done) {
        TweenMax.to(el, 0.3, { opacity: 1, height: '48px', ease: Power1.easeInOut, onComplete: done })
      },
      leave (el, done) {
        TweenMax.set(el, { overflow: 'hidden' })
        TweenMax.to(el, 0.3, { opacity: 0, height: 0, y: ' -100%', ease: Power1.easeInOut, onComplete: done })
      },
      afterEnter (el) {
        el.style.opacity = null
        el.style.height = null
      },
      showList (el, done) {
        // const elHeight = this.$refs.list.$el.offsetHeight
        // TweenMax.to(el, 0.3, { opacity: 1, height: elHeight + 'px', ease: Power1.easeInOut, onComplete: done })
        done()
      },
      hideList (el, done) {
        // TweenMax.set(el, { overflow: 'hidden' })
        // TweenMax.to(el, 0.3, { opacity: 0, height: 0, y: ' -100%', ease: Power1.easeInOut, onComplete: done })
        done()
      }
    },
    components: {
      ListItem,
      draggable
    }
  }
</script>

<style lang="scss" scoped>
  $animation-duration: 30s;
  p {
    padding: 20px;
    margin-bottom: 0;
    font-size: 24px;
    text-align: center;
    em {
      font-weight: 600;
    }
  }

  .list {
    overflow: hidden;
    transition: transform 0.2s ease-in-out, margin-top 0.2s ease-in-out;

    &-view__content,
    &-view__suggestions {
      background-color: #fff;
      margin-bottom: 16px;
    }
  }

  .list-view__suggestions {
    &.empty {
      margin-bottom: 0;
    }
  }

  .shopping {
    margin-top: 50vh;
    /*transform: translateY(50vh);*/
  }

  .suggestions-title {
    background-color: #fff;
    margin: 16px 0 0;
  }

  .sortable-ghost {
    background: rgba(0,0,0,0.15);
    & > /deep/ a {
      opacity: 0 !important;
    }
  }

  .sortable-chosen.sortable-drag {
    opacity: 1 !important;
    border-radius: 5px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease-in-out;
  }

</style>




// WEBPACK FOOTER //
// ShowList.vue?c36d6c7c